/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo } from 'react';
import { Form, Button, Dropdown } from 'react-bootstrap';
import { FaChevronLeft } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import LOGO_IMG from '../../client/assets/logo.png';
import './index.scss';
import {
  useCloudPassRedirectionHandlerAffiliates,
  useMsoConfigFetch
} from '../../components/IdpSelectionModal/hooks';
import ServiceApi from '../../services/serviceApi';
import config from '../../client/config';

const getReturnUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('return_url');
}

function MsoSelectPage() {
  const { t } = useTranslation();
  const service = new ServiceApi();
  const initialState = {
    isOpen: true,
    location: window.location,
    translate: () => { },
    parameters: {
      country: 'PE',
      client_id: config.clientShortName,
      returnUrl: getReturnUrl(),
      failureRedirect: window.location.href,
    }
  };

  const { __TBX_ENV__ } = window;

  const { state, setState } = useMsoConfigFetch(initialState);
  const redirect = useCloudPassRedirectionHandlerAffiliates(initialState, state);

  const msoByCountry = useMemo(() => {
    return state.mso && state.mso.filter(e => e.countryCode === state.country);
  }, [state.mso, state.country]);

  const idps = useMemo(() => {
    return msoByCountry.length === 1 ? msoByCountry[0].idp : [];
  }, [msoByCountry]);

  const countryClickHandler = useCallback((country) => {
    setState({ country });
  });

  const selectValidMSO = useCallback((country) => {
    country = country.toUpperCase();
    let selectedCountry = '';
    const defaultUserCountry = state.mso.find(e => e.countryCode === country);
    if (defaultUserCountry) {
      // If the ip Country of user is within the allowed countries, select that
      selectedCountry = defaultUserCountry.countryCode;
    } else {
      // first element of the countries that are arranged alphabetically
      selectedCountry = state.mso[0].countryCode;
    }
    return selectedCountry;
  }, [state.mso]);

  const getGeoInfo = async () => {
    const urlCountry = initialState.parameters?.country;
    if (urlCountry) {
      const countryCode = selectValidMSO(urlCountry);
      countryClickHandler(countryCode);
      return;
    }
    try {
      const response = await service.getCountryCodeByIp();
      const countryCode = selectValidMSO(response.country_code, true);
      countryClickHandler(countryCode);
    } catch (e) {
      countryClickHandler(state.mso[0].countryCode);
    }
  };

  useEffect(() => {
    setState({ idpsInFooter: idps.filter(idp => idp.showInFooter) });
  }, [idps]);

  useEffect(() => {
    if (state.mso.length > 0) {
      getGeoInfo();
    }
  }, [state.mso]);

  const goBack = () => {
    const returnUrl = getReturnUrl();
    if (returnUrl) {
      window.location.href = returnUrl;
      return;
    }
    window.history.back();
  };

  return (
    <>
      <div className='msoSelectPage'>
        { <div className='ligamax-logo'>
          <img src={LOGO_IMG} alt='logoliga' id='ligamaxlogo' />
        </div> }
        <div className='msoSelectPage__jumbotron'>
          <div className='button-back-container'>
            <Button className='button-back' onClick={() => goBack()}>
              <FaChevronLeft />
            </Button>
            <h1 className='page-title'>{t('MsoSelectPage.title')}</h1>
          </div>
          <div>
            <p className='page-subtitle'>{t('MsoSelectPage.subtitle')}</p>
          </div>
          <Form.Group className={'select-country'}>
            <div className="idps">
              {idps.map(idp => (
                !idp.showInFooter &&
                <LoginLinkCP
                  {...idp}
                  redirect={redirect}
                  key={idp.shortName}
                  setState={setState}
                  length={idps.length}
                />
              ))}
            </div>
          </Form.Group>
        </div>
        {
          !!state.idpsInFooter?.length &&
          <div className={'footerIdps'}>
            {state.idpsInFooter.map((idp, i) => {
              return <>
                <LoginLinkInFooter
                  {...idp}
                  redirect={redirect}
                  key={idp.shortName}
                  setState={setState}
                  length={idps.length}
                />
                {i !== (state.idpsInFooter?.length - 1) && <label className='label-footer'>|</label>}
              </>;
            })
            }
          </div>
        }
      </div>
    </>
  );
};


const LoginLinkInFooter = props => {
  return (
    <button
      onClick={() => {
        props.setState({ loading: true });
        props.redirect(props);
      }}
      className={'idp'} >
      {props.description}
    </button >);
};


const LoginLinkCP = props => (
  <div className={'idp-item'} onClick={() => {
    props.setState({ loading: true });
    props.redirect(props);
  }}>
    <div className="text-center" style={{ cursor: 'pointer', marginBottom: '10px' }}>
      <img
        className="img-responsive"
        src={props.logo}
        style={{ marginLeft: 'auto', marginRight: 'auto', maxHeight: 55 }}
        alt={props.shortName}
      />
      <p
        className='idp-description'>{props.description}</p>
    </div>
  </div>
);

export default (MsoSelectPage);
